'use client';

import { Toaster } from '@/shared/ui/toaster';
import '@smastrom/react-rating/styles.css';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { ReactNode } from 'react';
import 'swiper/css';

import AutoAuthProvider from './auto-auth';
import ChakraUIProvider from './chakra';
import PlatformProvider from './platform';
import TanstackQueryClientProvider from './tanstack-query-client';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <TanstackQueryClientProvider>
      <NuqsAdapter>
        <ChakraUIProvider>
          <PlatformProvider>
            <AutoAuthProvider>{children}</AutoAuthProvider>
          </PlatformProvider>
          <Toaster />
        </ChakraUIProvider>
      </NuqsAdapter>
    </TanstackQueryClientProvider>
  );
}
